export default {
   // Promotions Admin
  "userPromotionsAdmin.add": "Add",
  "userPromotionsAdmin.details": "Details",
  "userPromotionsAdmin.edit": "Edit",
  "userPromotionsAdmin.delete": "Delete",
  "userPromotionsAdmin.delete.confirm.title": "Delete Configuration",
  "userPromotionsAdmin.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "userPromotionsAdmin.delete.confirm.okText": "Confirm",
  "userPromotionsAdmin.delete.confirm.cancelText": "Cancel",
  "userPromotionsAdmin.modal.title": "Promotion Configuration",
  "userPromotionsAdmin.thead.createdAt": "Created At",
  "userPromotionsAdmin.thead.updatedAt": "Updated At",
  "userPromotionsAdmin.thead.action": "Action",

  // Promotion fields
  "userPromotionsAdmin.thead.id": "ID",
  "userPromotionsAdmin.thead.documentId": "Document ID",
  "userPromotionsAdmin.thead.sort": "Sort",
  "userPromotionsAdmin.thead.itemName": "Item Name",
  "userPromotionsAdmin.thead.itemId": "Item ID",
  "userPromotionsAdmin.thead.content": "Content",
  "userPromotionsAdmin.thead.listToDdetailText": "Detail Text",
  "userPromotionsAdmin.thead.listOpenType": "Open Type",
  "userPromotionsAdmin.thead.openPaymentBindBonusId": "Bind Bonus ID",
  "userPromotionsAdmin.thead.itemSubName": "Sub Name",
  "userPromotionsAdmin.thead.isMessage": "Is Message",
  "userPromotionsAdmin.thead.publishedAt": "Published At",
  "userPromotionsAdmin.thead.locale": "Locale",
  "userPromotionsAdmin.thead.banner": "Banner",
  "userPromotionsAdmin.thead.seo": "SEO",
  "userPromotionsAdmin.thead.listTitleIcon": "Title Icon",
  "userPromotionsAdmin.thead.bindSite": "Bind Site",
  "userPromotionsAdmin.thead.createdBy": "Created By",
  "userPromotionsAdmin.thead.updatedBy": "Updated By",
  "userPromotionsAdmin.thead.localizations": "Localizations",
  "userPromotionsAdmin.thead.status": "Status",

  // SEO fields
  "userPromotionsAdmin.thead.metaTitle": "Meta Title",
  "userPromotionsAdmin.thead.metaDescription": "Meta Description",
  "userPromotionsAdmin.thead.metaImage": "Meta Image",
  "userPromotionsAdmin.thead.keywords": "Keywords",
  "userPromotionsAdmin.thead.metaRobots": "Meta Robots",
  "userPromotionsAdmin.thead.metaViewport": "Meta Viewport",
  "userPromotionsAdmin.thead.canonicalURL": "Canonical URL",
  "userPromotionsAdmin.thead.structuredData": "Structured Data"
};